"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geo = void 0;
var Geo = /** @class */ (function () {
    function Geo(data) {
        var coordinates = data.coordinates;
        if (coordinates) {
            this.coordinates = {
                latitude: coordinates.latitude,
                longitude: coordinates.longitude,
            };
        }
        this.ipAddress = data.ipAddress;
        this.country = data.country;
        this.city = data.city;
    }
    return Geo;
}());
exports.Geo = Geo;
//# sourceMappingURL=geo.js.map